// Buscadores, rastreadores de IA y herramientas de análisis conocidos. Lista explícita: un patrón
// genérico como /bot/ también atrapaba móviles reales (p. ej. la marca CUBOT).
export const BOT_UA =
  /googlebot|google-inspectiontool|storebot-google|adsbot-google|mediapartners-google|apis-google|bingbot|bingpreview|msnbot|yandexbot|yandeximages|baiduspider|duckduckbot|slurp|applebot|petalbot|seznambot|sogou|exabot|facebookexternalhit|facebot|twitterbot|linkedinbot|pinterestbot|telegrambot|discordbot|slackbot|gptbot|oai-searchbot|chatgpt-user|claudebot|claude-user|claude-searchbot|anthropic-ai|perplexitybot|perplexity-user|ccbot|amazonbot|bytespider|meta-externalagent|semrushbot|ahrefsbot|mj12bot|dotbot|rogerbot|screaming frog|crawler|spider|lighthouse|pagespeed|headlesschrome/i;

export function isBot(): boolean {
  try {
    return BOT_UA.test(navigator.userAgent || "");
  } catch {
    return false;
  }
}
